{
  "version": 1,
  "asset_id": "b7bd5883-bd25-40d0-931d-9b68edaa9f81",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b7bd5883-bd25-40d0-931d-9b68edaa9f81/hiatal-type-iv-patient-before-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b7bd5883-bd25-40d0-931d-9b68edaa9f81/hiatal-type-iv-patient-before-1200.webp",
  "original_filename": "hiatal-type-iv-patient-before-1200.webp",
  "size": 107130,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:46Z"
}
